




import { defineComponent, computed, getCurrentInstance } from "vue";

export default defineComponent({
  setup() {
    const instance = getCurrentInstance();
    const numberOfEvents = computed(
      () =>
        instance.proxy.$store.getters["collaboration/numberOfSelectedEvents"]
    );
    return { numberOfEvents };
  }
});
